
import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { StringFilterPipe } from '../../../pipes';
import { AppStateHolder } from '../../../shared';
import { UserActivitiesService } from './user-activities.service';

@Component({
    selector: 'calendar-search-owner',
    templateUrl: 'search-owner.component.html',
    host: {
        '(document:click)': 'handleClick($event)'
    },
    standalone: true,
    imports: [FormsModule, StringFilterPipe, TranslateModule]
})

export class SearchOwnerComponent implements OnInit {
  appStateHolder = inject(AppStateHolder);
  private service = inject(UserActivitiesService);


  owners: any[];
  findOwners: any[];

  term: string;
  status: string = 'ok';

  showSearch: boolean = false;

  private _calendar: any;
  @Output() selected: EventEmitter<any> = new EventEmitter();

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
  }

  ngOnInit(): void {
    if (this._calendar === undefined) {
      this.status = 'busy';
      this.service
        .getAllOwners()
        .subscribe(result => {
          this.owners = result.sort((a: any, b: any): number => {
            if (a.fullName.toLowerCase() < b.fullName.toLowerCase()) return -1;
            if (a.fullName.toLowerCase() > b.fullName.toLowerCase()) return 1;
            return 0;
          });
          this.status = 'ok';
        });
    }
  }

  handleClick(event) {
    this.findOwners = null;
  }

  get calendar(): any {
    return this._calendar;
  }

  @Input()
  set calendar(calendar: any) {

    this.findOwners = null;
    this._calendar = calendar;
    this.status = 'busy';
    this.service
      .getCandidatesOwners(calendar)
      .subscribe(result => {
        this.owners = result.sort((a: any, b: any): number => {
          if (a.fullName.toLowerCase() < b.fullName.toLowerCase()) return -1;
          if (a.fullName.toLowerCase() > b.fullName.toLowerCase()) return 1;
          return 0;
        });
        this.status = 'ok';
      });
  }

  onClick() {
    this.showSearch = true;
  }

  onClickedOutside(event: any) {
    this.showSearch = false;
  }

  searchOwners(term: String): void {
    if (term.length < 3) {
      this.findOwners = null;
      return;
    }

    this.findOwners = this.owners
      .filter(function (owner) {
        return owner.fullName.toUpperCase()
          .indexOf(term.toUpperCase()) >= 0;
      });
  }

  onSelectOwner(owner): void {
    this.selected.next(owner);
    this.findOwners = null;
    this.showSearch = false;
  }
}
